
<template>
    <div :class="getRowCss()">
        <div :class="getLabelCss()">
            <slot name="label"/>
        </div>
        <div :class="getFieldsCss()">
            <slot name="fields"/>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "FormRow",
    props: {
        labelWidth: {
            type: [Number, String],
            default: 4
        },
        fieldWidth: {
            type: [Number, String],
            default: 0
        },
        labelCss: {
            type: String,
            default: ""
        },
        fieldCss: {
            type: String,
            default: ""
        },
        rowCss: {
            type: String,
            default: "mb-2"
        }
    },
    methods: {
        getRowCss(): string {
            return `row ${this.rowCss}`;
        },
        getLabelCss(): string {
            return `col-lg-${this.labelWidth.toString()} col-form-label${this.labelCss ? " " + this.labelCss : ""}`;
        },
        getFieldsCss(): string {
            let fieldWidth = this.fieldWidth;
            if (!fieldWidth)
                fieldWidth = 12 - this.labelWidth;
            return `col-lg-${fieldWidth}${this.fieldCss ? " " + this.fieldCss : ""}`;
        }
    }
});

</script>
